import { defineStore } from "pinia";
import { ClearToken, GetToken, SaveToken } from "../helpers/encrypt";
// import url from "../axios/url";
// import axios from "axios";
import { AxiosClient } from "../axios/axios";
import router from "../router";
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    name: null,
    email: null,
    prvi: [],
    error: null,
    errors: {},
    isLoading: false,
  }),

  getters: {
    isLoggedIn: () => GetToken() !== null,
  },
  actions: {
    //Clear errors Action Start
    async clearErrors() {
      this.error = "";
      this.errors = {};
    },
    //clear errors end start
    //Login Action Start
    async login(formData) {
      this.isLoading = true;
      //  SaveToken('26399|wjjPvcgsZ1GfMh3iqnXoaFnk38f0B3cu1qKV2CUG15ecb985');
      //       this.isLoading = false;
      //       router.push({ name: "default" });
      return new Promise((resolve, reject) => {
        AxiosClient.post(`/login`, formData, {
          withCredentials: true,
        })
          .then((res) => {
            SaveToken(res.data.userToken);
            // this.isLoading = false;
            router.push({ name: "default" });
            // resolve(res)
          })
          .catch((error) => {
            this.isLoading = false;
            reject(error);
          });
      });
    },
    //Login Action End
    //Logout Action Start
    async logout() {
      try {
        ClearToken();
        this.user = null;
        this.isLoading = false;
        router.push({ name: "login" });
      } catch (error) {
        ClearToken();
        this.error = error?.response?.data?.message ?? "An error occurred";
        this.user = null;
        this.isLoading = false;
        router.push({ name: "login" });
      }
    },
    //Logout Action End

    // Get User Action Start
    async getUser() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`/user`)
          .then((res) => {
            this.user = res?.data.info;
            this.name = res?.data.info?.name;
            this.prvi = res?.data?.info.abilities;
            resolve(res);
          })
          .catch((error) => {
            if (error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End

    // get privileges

    getPrivileges() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`privilage`, {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token") ?? this.token,
          },
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // end of get privileges

    // reset password 
    resetPassword(payload) {
      return new Promise((resolve, reject) => {
        AxiosClient.put(`v1/d/user/ikw`, payload,{
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token") ?? this.token,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

  },
});
